import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';
import Modal from 'components/shared/Modal/Modal';

const PhoneSupportModal = ({ isOpen, onClose, supportData }) => {
  const practiceSupport = supportData?.practiceSupport;

  const contacts = [
    {
      role: 'Management Consultant',
      contact: practiceSupport?.consultant
    },
    {
      role: 'Onboarding Architect',
      contact: practiceSupport?.onboardingArchitect
    },
    {
      role: 'Inside Representative',
      contact: practiceSupport?.insideRepresentative
    }
  ].filter((c) => c.contact?.phone);

  return (
    <Modal
      handleOpen={isOpen}
      handleClose={onClose}
      slideFromRight={false}
      className="!w-[500px]"
      customTitle={
        <span className="flex items-center gap-2">
          <Icon icon="call-calling-mono" color="primary" size={20} />
          Contact Myriad Support
        </span>
      }
      footer={
        <div className="flex w-full justify-start">
          <Button text="Close" size="small" style="outlined" color="neutral" onClick={onClose} />
        </div>
      }>
      <div className="flex flex-col gap-3">
        {contacts.length > 0 ? (
          contacts.map((item) => (
            <div key={item.role} className="flex items-center justify-between">
              <span className="text-sm text-neutral-700">{item.role}</span>
              <span className="text-sm font-500 text-neutral-700">{item?.contact?.phone}</span>
            </div>
          ))
        ) : (
          <p className="text-sm text-neutral-500">No support contacts available yet.</p>
        )}

        <div className="border-t border-neutral-200 pt-3">
          <span className="text-sm text-neutral-700">You can also reach us by email at: </span>
          <a
            href="mailto:onboarding@myriadsystems.ai"
            className="text-sm font-500 text-primary-500 hover:underline">
            onboarding@myriadsystems.ai
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default PhoneSupportModal;
